import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../index';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: string;
  containerClassName?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, containerClassName, error, children, ...props }, ref) => (
    <div className={cn('relative w-full', containerClassName)}>
      <select
        ref={ref}
        className={cn(
          'flex h-9 w-full rounded-lg border pl-3 pr-8 py-2 text-sm transition-colors appearance-none cursor-pointer',
          'bg-[var(--input)] border-[var(--input-border)] text-[var(--fg)]',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] focus-visible:border-transparent',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error && 'border-[var(--destructive)]',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-[var(--fg-muted)] pointer-events-none" />
      {error && <p className="mt-1 text-xs text-[var(--destructive)]">{error}</p>}
    </div>
  ),
);
Select.displayName = 'Select';
